import type { AdvancedFilterRegistration } from "./types.ts";

const registry = new Map<string, AdvancedFilterRegistration>();
const warnedMisses = new Set<string>();

export function registerFilter(name: string, reg: AdvancedFilterRegistration): void {
  registry.set(name.toUpperCase(), reg);
}

/**
 * Every filter type registered so far, upper-cased as the registry stores them.
 *
 * Exists so the filter gallery can check its own sample list against reality: a filter added to
 * registerAll.ts but not to the gallery is invisible there, and nothing else would ever say so.
 * Import `registerAll.ts` before calling this — registration happens as a side effect of that
 * module, so an early call returns a short list rather than an empty one, which is the more
 * confusing failure.
 */
export function registeredFilterNames(): string[] {
  return [...registry.keys()].sort();
}

export function getFilter(name: string): AdvancedFilterRegistration | undefined {
  const key = name.toUpperCase();
  const hit = registry.get(key);
  if (!hit && name && !warnedMisses.has(key)) {
    warnedMisses.add(key);
    console.warn(`[advancedFilters] unknown FilterType '${name}' — column/parameter uses this filter but no handler is registered. Add it in registerAll.ts or migrate from WebAdmin2.`);
  }
  return hit;
}
